import { Link } from 'react-router-dom';
import { trendingArticles } from '@/mocks/articles';

export default function TrendingGrid() {
  return (
    <section id="trending" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-6 h-6 flex items-center justify-center bg-primary-500 rounded-md">
                <i className="ri-fire-line text-background-50 text-xs"></i>
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                今日吃瓜
              </h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base">
              全网最热爆料实时追踪，精彩不容错过
            </p>
          </div>
          <Link
            to="/category/star"
            className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {trendingArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                {article.isExclusive && (
                  <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    独家
                  </span>
                )}

                <span className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  <i className="ri-fire-line text-primary-400 text-xs"></i>
                  {article.hotScore >= 10000
                    ? `${(article.hotScore / 10000).toFixed(1)}万`
                    : article.hotScore}
                </span>

                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2.5 py-1 mb-2 bg-accent-500/80 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-background-50 leading-snug line-clamp-2 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <p className="mt-1.5 text-background-50/60 text-xs line-clamp-1">
                    {article.date} · {article.author}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}